/**
 * アプリケーション定義例外のインターフェース
 */
interface AppErrorInterface {
  /** エラーメッセージ */
  message: string
  /** エラー名 */
  name: string
}

/**
 * アプリケーション例外の基底クラス
 *   アプリケーション例外を追加する場合、このクラスを継承して定義する
 *   命名は〜AppError
 */
class AppError extends Error implements AppErrorInterface {
  /**
   * コンストラクタ
   *
   * @param message エラーメッセージ
   */
  constructor(message: string) {
    super(message)
    this.name = 'AppError'
  }
}

/**
 * 認証エラー(生徒権限)
 */
export class StudentAuthAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('生徒認証エラー')
    this.name = 'StudentAuthAppError'
  }
}

/**
 * 認証エラー(教室権限)
 */
export class TeacherAuthAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('教室認証エラー')
    this.name = 'TeacherAuthAppError'
  }
}

/**
 * 認証エラー(塾権限)
 */
export class AcademyAuthAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('塾認証エラー')
    this.name = 'AcademyAuthAppError'
  }
}

/**
 * 認証エラー(システム管理者権限)
 */
export class AdminAuthAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('システム管理者認証エラー')
    this.name = 'AdminAuthAppError'
  }
}

/**
 * APIパスワード変更要求エラー(Unauthorized+フラグの返却あり)
 */
export class ApiRequireResetPasswordAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('APIパスワード変更要求エラー')
    this.name = 'ApiRequireResetPasswordAppError'
  }
}

/**
 * API400エラー(BadRequest)
 */
export class ApiBadRequestAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('API400エラー')
    this.name = 'ApiBadRequestAppError'
  }
}

/**
 * API404エラー(NotFound)
 */
export class ApiNotFoundAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('API404エラー')
    this.name = 'ApiNotFoundError'
  }
}

/**
 * API409エラー(Conflict)
 */
export class ApiConflictAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('API409エラー')
    this.name = 'ApiConflictAppError'
  }
}

/**
 * API423エラー(Locked)
 */
export class ApiLockedAppError extends AppError {
  /**
   * コンストラクタ
   */
  constructor() {
    super('API423エラー')
    this.name = 'ApiLockedAppError'
  }
}
